// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { dealerInformationStyles } from "@eisinc/Overrides/Widgets/DealerDetails/DealerInformation";
import Phone from "@insite/mobius/Icons/Phone";
import { css } from "styled-components";

dealerInformationStyles.hoursContentGridItem = {
    width: 4,
    css: css`
            padding-left: 40px;
        `,
};
dealerInformationStyles.googleMapsDirectionLinkGridItem = {
    width: 4,
};
dealerInformationStyles.visitWebsiteLinkGridItem = {
    width: 4,
};
dealerInformationStyles.locationContentModal = {
    sizeVariant: "small",
    cssOverrides: {
        modalTitle: css`
                padding: 10px 20px;
            `,
        modalContent: css`
                padding: 20px;
            `,
    },
};


dealerInformationStyles.phoneLink = {
    icon: {
        iconProps: {
            src: Phone,
            size: 16,
            css: css`
                    margin-right: 0;
                `,
        },
        position: "left",
    },
    typographyProps: {
        css: css`
                padding-left: 10px;
            `,
    },
};

dealerInformationStyles.addressInfoIcon = {
    src: "MapPin",
    color: "primary",
    size: 16,
};